<template>
  <transition name="modal" appear>
<!--    <div class="modal modal-overlay">-->
    <div class="modal modal-overlay" @mousedown.self="$emit('close')">
      <div class="modal-window">
        <div class="modal-content">
          <slot/>
        </div>
<!--        <footer class="modal-footer">-->
<!--          <slot name="footer">-->
<!--            <button @click="$emit('close')">Close</button>-->
<!--          </slot>-->
<!--        </footer>-->
        <button class="btn-close" type="button" @click="$emit('close')">
          <i class="xi-close"></i>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Modal"
}
</script>

<style lang="scss">
.modal {
  .modal-header {
    text-align: center;
    height: 60px;
    line-height: 60px;
    background: #000;
    color: #fff;
    text-align: center;
    font-size: 20px;
    padding: 0 1.5rem;

    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    margin-top: -1px;

    @include respond(mobile) {
      border-top-left-radius: 7px;
      border-top-right-radius: 7px;

      font-size: 14px;
      font-weight: bold;

      height: 42px;
      line-height: 42px;
    }
  }

  .modal-body {
    padding: 1.3rem 1.5rem 1.3rem;
    @include scrollbar();
  }

  .modal-footer {
    padding: 1.3rem 1.5rem 1.3rem;
  }
}

</style>

<style lang="scss" scoped>
.modal {
  &.modal-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 30;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  &-window {
    position: relative;
    background: #fff;
    //overflow: hidden;
    //padding: 2.5rem 4.3rem;
    padding: 0 0 1rem;
    @include border-round(10px);

    @include respond(mobile) {
      @include border-round(7px);
    }
  }

  &-content {
    //padding: 1.5rem;
  }

  &-footer {
    //background: #ccc;
    //padding: 1rem 1.5rem;
    text-align: right;
  }

  .btn-close {
    position: absolute;
    width: 30px;
    height: 30px;
    background-color: transparent;
    padding: 0;
    border: 0;
    color: #fff;
    top: 13px;
    right: 10px;
    font-size: 15px;

    @include respond(mobile) {
      top: 5px;
      right: 5px;
      font-size: 12px;
    }
  }
}

.modal-window {
  @include respond(mobile) {
    width: 90%;
  }
}

// 오버레이 트랜지션
.modal-enter-active, .modal-leave-active {
  transition: opacity 0.4s;

  // 오버레이에 포함되어 있는 모달 윈도의 트랜지션
  .modal-window {
    transition: opacity 0.4s, transform 0.4s;
  }
}

// 딜레이가 적용된 모달 윈도가 제거된 후에 오버레이가 사라짐
.modal-leave-active {
  transition: opacity 0.6s ease 0.4s;
}

.modal-enter, .modal-leave-to {
  opacity: 0;

  .modal-window {
    opacity: 0;
    transform: translateY(-20px);
  }
}
</style>
